import { OrderTrackingIntegrationType } from "@redotech/order-tracking-common/order-tracking-types";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getActiveOrderTrackingIntegrations = {
  name: "getActiveOrderTrackingIntegrations" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    integrations: z.array(
      z.object({
        type: createEnum(Object.values(OrderTrackingIntegrationType)),
        source: z.string(),
      }),
    ),
  }),
};
